// @flow strict
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from 'react';
import { UnViewed, Viewed } from '@ansarada/icons';
import { Link } from '../../../internal/Button';

import { Highlight } from './highlight';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';

import HomeBG from '../../../static/images/homepage-background.png';

const homepageBackground = HomeBG;

const products = [
  {
    title: 'Data Room',
    description:
      'Confidently control the outcome from the outset in M&A, divestments, capital raising, restructures and more.',
    image: homepageBackground,
    cta: {
      text: 'Start Preparing for FREE',
      url: 'https://www.ansarada.com/free-trial',
    },
  },
  {
    title: 'Deals',
    description: `Confidently manage and organise the entire deal process <br /> from end-to-end`,
    image: homepageBackground,
    cta: {
      text: 'Start Preparing for FREE',
      url: 'https://www.ansarada.com/free-trial',
    },
  },
  {
    title: 'Procurement',
    description: `The only software solution purpose-built to securely run complex, high value infrastructure procurement.`,
    image: homepageBackground,
    cta: {
      text: 'Learn more',
      url: 'https://www.ansarada.com/rfp-tender-advisors',
    },
  },
  {
    title: 'File sharing',
    description: `Secure file sharing and collaboration that helps teams gain total confidence with bank-grade security.`,
    image: homepageBackground,
    cta: {
      text: 'Learn more',
      url: 'https://www.ansarada.com/features/secure-file-share',
    },
  },
];

export function HomeHero() {
  const [current, setCurrent] = React.useState(0);
  const [timer, setTimer] = React.useState<IntervalID | null>(null);
  const body = React.useRef<HTMLElement | null>(null);
  const countRef = React.useRef<number>(current);
  countRef.current = current;

  // const fadeIn = () => {
  //   const currentBody = body.current;
  //   if (!currentBody) return;
  //   currentBody.classList.add('fadeIn');
  //   setTimeout(() => {
  //     currentBody.classList.remove('fadeIn');
  //   }, 400);
  // };

  const startTimer = () => {
    setTimer(
      setInterval(() => {
        const next = countRef.current + 1;
        setCurrent(next < products.length ? next : 0);
        // fadeIn();
      }, 8e3),
    );
  };

  React.useEffect(() => {
    startTimer();
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [products]);

  return (
    <div className={styles.homeHeroBackground}>
      <div className={styles.homeHeroContainer}>
        <div>
          <p className={styles.homeHeroTitle}>
            <span className={styles.homeHeroText}>Get my </span>
            <Highlight products={products} current={current} />
            <span className={styles.homeHeroText}> in order</span>
          </p>

          <p
            ref={body}
            className={styles.homeHeroSubtitle}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: products[current].description }}
          />

          <span>
            <span className={styles.homeHeroSpace}>
              <Link variant="Primary" href={products[current].cta.url}>
                {products[current].cta.text}
              </Link>
            </span>
          </span>

          <div className={styles.homeHeroPagination}>
            {products.map((_, index) => (
              <span
                onClick={() => {
                  if (timer) {
                    clearInterval(timer);
                    startTimer();
                  }
                  setCurrent(index);
                }}
                className={styles.homeHeroPaginationItem}
              >
                {index === current ? <UnViewed color="#CAF933" /> : <Viewed color="#fff" />}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeHero;
